<template>
  <div class="blog_matrix" ref="blog_block">
    <Overlay class="c_hero_banner__overlay" ref="videoBannerOverlay" theme="full" :show-close-button="true">
      <div class="c_box--pos--relative c_hero_banner__overlay__video">
        <MediaVideo loading="eager" :source="videoSource" :video-id="videoId"></MediaVideo>
      </div>
    </Overlay>
    <div
      class="blog_matrix__block lp__block lp__block_2023"
      v-for="(block, blockIndex) in matrixBlocks"
      :key="blockIndex"
      :class="[
        'blog_matrix__block--' + block.typeHandle,
        block.typeHandle == 'mediaContacts' ? 'c_box--break_out' : '',
        blockClasses(block),
      ]"
      :style="blockStyles(block)"
      :data-block-theme="block.colors || 'blackTextWhiteBackground'"
    >
      <div class="c_wrapper c_wrapper--950">
        <div v-if="block.typeHandle == 'image' && block.image && block.image.length">
          <div
            v-if="block.imageType == 'fullWidth'"
            class="c_box--break_out blog_matrix__block--image__container"
            :style="'--image-height-restraint:' + block.imageHeightRestraint + ';'"
          >
            <MediaImage
              v-if="block.image[0].blogNewsUncropped"
              :alt="block.image[0].title"
              :sources="[
                { srcset: block.image[0].blogNewsUncropped.srcsetWebp, type: 'image/webp' },
                { srcset: block.image[0].blogNewsUncropped.srcset },
              ]"
            />
          </div>
          <div
            v-else
            class="blog_matrix__block--image__container"
            :style="'--image-height-restraint:' + block.imageHeightRestraint + ';'"
          >
            <MediaImage
              v-if="block.image[0].blogNewsUncropped"
              :alt="block.image[0].title"
              :sources="[
                { srcset: block.image[0].blogNewsUncropped.srcsetWebp, type: 'image/webp' },
                { srcset: block.image[0].blogNewsUncropped.srcset },
              ]"
            />
          </div>

          <p class="blog_matrix__block--image__caption" v-if="block.caption" v-html="block.caption"></p>
        </div>
        <div v-if="block.typeHandle == 'text' && (block.header || block.text)">
          <h2 class="c_header c_header--9 c_text--graphik_bold" v-if="block.header" v-html="block.header"></h2>
          <div class="c_text" v-if="block.text" v-html="block.text"></div>
        </div>
        <div v-if="block.typeHandle == 'basicText'">
          <BasicText :block="block" />
        </div>
        <div v-if="block.typeHandle == 'blockquote' && block.blockquote">
          <div
            class="c_header--9 c_text--graphik_bold"
            :class="block.quoteByline || block.quoteBylineDetails ? 'blog_matrix__block--blockquote__quote' : ''"
            v-if="block.blockquote"
            v-html="block.blockquote"
          ></div>
          <p class="c_text--graphik_bold blog_matrix__block--blockquote__byline" v-if="block.quoteByline">
            {{ block.quoteByline }}
          </p>
          <p class="blog_matrix__block--blockquote__byline_details" v-if="block.quoteBylineDetails">
            {{ block.quoteBylineDetails }}
          </p>
        </div>
        <div v-if="block.typeHandle == 'links' && block.links">
          <h3 class="c_header--4 c_text--graphik_semibold blog_matrix__block--links__header" v-if="block.header">
            {{ block.header }}
          </h3>
          <div class="blog_matrix__block--links__link" v-for="(link, linkIndex) in block.links" :key="linkIndex">
            <LinkField :super-table-field="link" :button-attrs="{ unstyle: true, class: 'c_button--bold' }" />
          </div>
        </div>
        <div
          v-if="block.typeHandle == 'mediaContacts' && block.mediaContacts && block.mediaContacts.length"
          class="c_wrapper c_wrapper--950"
        >
          <h3
            class="c_header--9 c_text--graphik_bold blog_matrix__block--mediaContacts__header"
            v-if="block.header"
            v-html="block.header"
          ></h3>
          <Grid :columns="mediaContactColumns" gap="20px">
            <div
              v-for="(mediaContact, mediaContentIndex) in block.mediaContacts"
              :key="mediaContentIndex"
              class="blog_matrix__block--mediaContacts__mediaContact"
            >
              <p v-if="mediaContact.title">
                <strong>{{ mediaContact.title }}</strong>
              </p>
              <p v-if="mediaContact.descriptor">{{ mediaContact.descriptor }}</p>
              <p v-if="mediaContact.email">{{ mediaContact.email }}</p>
              <p v-if="mediaContact.phoneNumber">{{ mediaContact.phoneNumber }}</p>
            </div>
          </Grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasicText from 'Components/basic_text/BasicText.vue';
import Grid from 'Components/grid/Grid.vue';
import LinkField from 'Components/link_field/LinkField.vue';
import MediaImage from 'Components/image/MediaImage.vue';
import MediaVideo from 'Components/video/MediaVideo.vue';
import Overlay from 'Components/overlay/Overlay.vue';

export default {
  components: {
    BasicText,
    Grid,
    LinkField,
    MediaImage,
    MediaVideo,
    Overlay,
  },
  data() {
    return {
      videoId: '',
      videoSource: '',
    };
  },
  props: {
    matrixBlocks: Array,
  },
  computed: {
    mediaContactColumns() {
      if (this.$mq === 'lg') {
        return 3;
      } else if (this.$mq === 'md') {
        return 2;
      } else {
        return 1;
      }
    },
  },
  methods: {
    toggleVideo(videoId, videoSource) {
      this.videoId = videoId;
      this.videoSource = videoSource;
      console.log('videoId: ' + videoId);
      console.log('videoSource: ' + videoSource);
      this.$nextTick(() => {
        this.$refs.videoBannerOverlay.show();
      });
      event.preventDefault();
    },
    blockClasses(block) {
      const classes = [`lp__block--${block.typeHandle}`];
      // Add classes based on block type and style fields
      if (block.colors) {
        switch (block.colors) {
          case 'blackTextWhiteBackground':
            classes.push('c_box');
            break;
          case 'blackTextGrayBackground':
            classes.push('c_box--gray_235');
            break;
          case 'blackTextYellowBackground':
            classes.push('c_box--yellow');
            break;
          case 'whiteTextBlackBackground':
            classes.push('c_box--black');
            classes.push('c_text--white');
            break;
          case 'whiteTextDarkGrayBackground':
            classes.push('c_box--gray_41');
            classes.push('c_text--white');
            break;
          default:
            classes.push('c_box--white');
        }
      } else {
        classes.push('c_box--white');
      }
      return classes;
    },
    blockStyles(block) {
      const styles = {};

      // Add syles based on block type and style fields
      if (block.colors) {
        switch (block.colors) {
          case 'blackTextGrayBackground':
            styles['--block-bg-color'] = 'var(--color-gray_235)';
            break;
          case 'blackTextYellowBackground':
            styles['--block-bg-color'] = 'var(--color-yellow)';
            break;
          case 'whiteTextBlackBackground':
            styles['--block-bg-color'] = 'var(--color-black)';
            break;
          case 'whiteTextDarkGrayBackground':
            styles['--block-bg-color'] = 'var(--color-gray_41)';
            break;
          default:
            styles['--block-bg-color'] = 'var(--color-white)';
        }
      } else {
        styles['--block-bg-color'] = 'var(--color-white)';
      }
      return styles;
    },
  },
  created() {},
  mounted() {
    const component = this;
    this.$refs?.blog_block?.addEventListener('click', function (event) {
      if (!event.srcElement?.href) return;
      const url = event.srcElement?.href;
      // eslint-disable-next-line
      const regex =
        /^.*(?:(?:youtu\.be\/|youtube\.com\/(?:embed|v(?:i)?|e)\/)|(?:(?:watch)?\?v(?:i)?=|&v(?:i)?=))([^#&?]*).*/;
      const n = url.match(regex);
      if (n) {
        component.toggleVideo(n[1], 'youtube');
      }
      if (url.includes('youku')) {
        const id = url.split('id_')[1].slice(0, 13);
        component.toggleVideo(id, 'youku');
      }
    });
  },
};
</script>

<style lang="scss">
.blog_matrix {
  $self: &;
  @at-root #{$self}__block {
    $block: &;
    @at-root #{&}--text {
      .c_text {
        --text-fz: $lp_text_default_font_size;
      }
      overflow-x: auto;
      & + & {
        padding-top: px_to_rem(40);
      }
      table {
        @include table_styling;
        $_border: 1px solid $color_gray_191;
        box-sizing: border-box;
        border: $_border;
        overflow: auto;
        font-size: var(--text-fz);
        th {
          border-bottom: $_border;
        }
      }
    }
    @at-root .c_hero_banner__overlay {
      @at-root .c_hero_banner__overlay__video {
        width: 90vw;
        max-width: 100%;
        overflow: hidden;
        @include mq($mq_sm_to_md) {
          width: 70vw;
        }
        @include mq($mq_md_to_lg) {
          width: px_to_rem(800);
        }
      }
    }
    @at-root #{&}--blockquote {
      padding: px_to_rem(25) 0;
      @include mq($mq_sm_to_md) {
        padding: px_to_rem(50) 9%;
      }
      @at-root #{&} + #{$block}--image {
        padding-top: 0;
      }
      @at-root #{&} + #{$block}--mediaContacts {
        margin-top: 0;
      }
      @at-root #{&}__byline {
        line-height: 1.2;
        font-size: px_to_rem(18);
        padding-top: px_to_rem(20);
        @include mq($mq_sm_to_md) {
          @include fz(2, px_to_rem(25), 1300);
        }
      }
      @at-root #{&}__byline_details {
        line-height: 1.2;
        font-size: px_to_rem(18);
        @include mq($mq_sm_to_md) {
          @include fz(1.6, px_to_rem(20), 1300);
        }
      }
    }
    @at-root #{&}--image {
      padding: px_to_rem(30) 0;
      @at-root #{&} + #{$block}--blockquote {
        padding-top: px_to_rem(10);
      }
      @at-root #{&} + #{$block}--mediaContacts {
        margin-top: 0;
      }
      @at-root #{&}__caption {
        padding-top: px_to_rem(10);
        font-size: px_to_rem(16);
        color: $color_gray_112;
      }
      @at-root #{&}__container {
        text-align: center;
        img {
          width: auto;
          max-height: var(--image-height-restraint);
        }
      }
    }
    @at-root #{&}--links {
      margin-bottom: px_to_rem(20);
      @at-root #{&}__header {
        padding-bottom: px_to_rem(15);
      }
      @at-root #{&}__link {
        margin-right: px_to_rem(20);
        margin-bottom: px_to_rem(10);
      }
    }
    @at-root #{&}--mediaContacts {
      background: $color_gray_235;
      padding: px_to_rem(40) 0;
      margin-top: px_to_rem(40);
      margin-bottom: px_to_rem(40);
      @at-root #{&}__header {
        padding-bottom: px_to_rem(15);
      }
    }
    .small_caption {
      padding-top: 0.625rem;
      font-size: 0.8rem;
      color: var(--color-gray_112);
      text-align: center;
    }
    .small_caption_left {
      padding-top: 0.625rem;
      font-size: 0.8rem;
      color: var(--color-gray_112);
      text-align: left;
    }

    // Theming defaults (white bg, black fg)
    --blog-primary-bg: var(--color-red);
    --blog-primary-bg--hover: var(--color-red_179);
    --blog-primary-color: var(--color-white);
    --blog-primary-color--hover: var(--color-white);
    --blog-primary-border: var(--color-red);
    --blog-primary-border--hover: var(--color-red_179);

    --blog-secondary-bg: transparent;
    --blog-secondary-bg--hover: var(--color-red);
    --blog-secondary-color: var(--color-black);
    --blog-secondary-color--hover: var(--color-white);
    --blog-secondary-border: var(--color-red);
    --blog-secondary-border--hover: var(--color-red);

    // reset / apply themes by default
    a.c_button_2022--primary:hover,
    a.c_button_2022--secondary:hover {
      text-decoration: none;
    }
    a.c_button_2022--primary {
      background-color: var(--blog-primary-bg);
      border-color: var(--blog-primary-border);
      color: var(--blog-primary-color);
      &:hover {
        background-color: var(--blog-primary-bg--hover);
        border-color: var(--blog-primary-border--hover);
        color: var(--blog-primary-color--hover);
      }
    }
    a.c_button_2022--secondary {
      background-color: var(--blog-secondary-bg);
      border: 2px solid var(--blog-secondary-border);
      color: var(--blog-secondary-color);
      &:hover {
        background-color: var(--blog-secondary-bg--hover);
        border-color: var(--blog-secondary-border--hover);
        color: var(--blog-secondary-color--hover);
      }
    }

    // Specific theme overrides
    &[data-block-theme='blackTextYellowBackground'] {
      --blog-primary-bg: var(--color-red);
      --blog-primary-bg--hover: var(--color-red_179);
      --blog-primary-color: var(--color-white);
      --blog-primary-color--hover: var(--color-white);
      --blog-primary-border: var(--color-red);
      --blog-primary-border--hover: var(--color-red_179);

      --blog-secondary-bg: transparent;
      --blog-secondary-bg--hover: var(--color-black);
      --blog-secondary-color: var(--color-black);
      --blog-secondary-color--hover: var(--color-white);
      --blog-secondary-border: var(--color-black);
      --blog-secondary-border--hover: var(--color-black);
    }
    &[data-block-theme='blackTextGrayBackground'] {
      --blog-primary-bg: var(--color-red);
      --blog-primary-bg--hover: var(--color-red_179);
      --blog-primary-color: var(--color-white);
      --blog-primary-color--hover: var(--color-white);
      --blog-primary-border: var(--color-red);
      --blog-primary-border--hover: var(--color-red_179);

      --blog-secondary-bg: transparent;
      --blog-secondary-bg--hover: var(--color-black);
      --blog-secondary-color: var(--color-black);
      --blog-secondary-color--hover: var(--color-white);
      --blog-secondary-border: var(--color-black);
      --blog-secondary-border--hover: var(--color-black);
    }
    &[data-block-theme='whiteTextBlackBackground'] {
      --blog-primary-bg: var(--color-red);
      --blog-primary-bg--hover: var(--color-red_179);
      --blog-primary-color: var(--color-white);
      --blog-primary-color--hover: var(--color-white);
      --blog-primary-border: var(--color-red);
      --blog-primary-border--hover: var(--color-red_179);

      --blog-secondary-bg: transparent;
      --blog-secondary-bg--hover: var(--color-white);
      --blog-secondary-color: var(--color-white);
      --blog-secondary-color--hover: var(--color-black);
      --blog-secondary-border: var(--color-white);
      --blog-secondary-border--hover: var(--color-white);
    }
    &[data-block-theme='whiteTextDarkGrayBackground'] {
      --blog-primary-bg: var(--color-red);
      --blog-primary-bg--hover: var(--color-red_179);
      --blog-primary-color: var(--color-white);
      --blog-primary-color--hover: var(--color-white);
      --blog-primary-border: var(--color-red);
      --blog-primary-border--hover: var(--color-red_179);

      --blog-secondary-bg: transparent;
      --blog-secondary-bg--hover: var(--color-white);
      --blog-secondary-color: var(--color-white);
      --blog-secondary-color--hover: var(--color-black);
      --blog-secondary-border: var(--color-white);
      --blog-secondary-border--hover: var(--color-white);
    }
  }
  .lp__block {
    &--videoEmbed {
      --lp-block-padding: 2rem;
      padding: var(--lp-block-padding-top, var(--lp-block-padding, 0)) 0
        var(--lp-block-padding-bottom, var(--lp-block-padding, 0));
    }
    &--basicText {
      --lp-block-padding: 2rem;
      padding: var(--lp-block-padding-top, var(--lp-block-padding, 0)) 0
        var(--lp-block-padding-bottom, var(--lp-block-padding, 0));
    }
  }
}
</style>
